export default __webpack_public_path__ + "locales/ja-JP/PrivacyPage.json?hash=d1fbac8b65a2bdc4bd3a19e793fbda08";